import { createActionCreator } from '../../utils/helpers';

import { convertToFundingSearch } from './types';

export const requestConvertToFundingSearch = createActionCreator(
  convertToFundingSearch.request,
  'reportId',
  'promise',
);
